import { api } from "../api";

const fetchAll = async (model, options) => {
  let records = [];
  let page = await model.findMany({ first: 250, ...options });
  records = records.concat(page);
  while (page.hasNextPage) {
    page = await page.nextPage();
    records = records.concat(page);
  }
  return records;
};

/**
 * The planned audience (sendingSummary) is written before the sendings are
 * created from the browser: if their creation was interrupted (tab closed,
 * network loss, error), fewer contacts end up scheduled than planned.
 *
 * Returns a Map sendingBatchId -> { plannedContacts, scheduledContacts, isIncomplete }.
 */
export async function fetchBatchesCompleteness(customerId, sendingBatchIds) {
  const completeness = new Map();
  if (!sendingBatchIds.length) {
    return completeness;
  }

  const filter = {
    customerId: { equals: customerId },
    sendingBatchId: { in: sendingBatchIds },
  };
  const [sendings, summaries] = await Promise.all([
    fetchAll(api.sending, {
      filter,
      select: { sendingBatchId: true, contactList: true },
    }),
    fetchAll(api.sendingSummary, {
      filter,
      select: { sendingBatchId: true, audience: true },
    }),
  ]);

  for (const batchId of sendingBatchIds) {
    const plannedContacts = summaries
      .filter((s) => s.sendingBatchId === batchId)
      .reduce((sum, s) => sum + (s.audience || 0), 0);
    // Every status counts: sendings already sent were scheduled too.
    const scheduledContacts = sendings
      .filter((s) => s.sendingBatchId === batchId)
      .reduce((sum, s) => sum + (s.contactList?.length || 0), 0);
    completeness.set(batchId, {
      plannedContacts,
      scheduledContacts,
      isIncomplete: plannedContacts > 0 && scheduledContacts < plannedContacts,
    });
  }
  return completeness;
}
